import { render, staticRenderFns } from "./MchInfo.vue?vue&type=template&id=17d33e5e&scoped=true"
import script from "./MchInfo.vue?vue&type=script&lang=js"
export * from "./MchInfo.vue?vue&type=script&lang=js"
import style0 from "./MchInfo.vue?vue&type=style&index=0&id=17d33e5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d33e5e",
  null
  
)

export default component.exports